export default __webpack_public_path__ + "static/media/icon-qa.163769fe.svg";